import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Exploring } from "@/components/Exploring";
import { About } from "@/components/About";
import { Education } from "@/components/Education";
import { Experience } from "@/components/Experience";
import { Projects } from "@/components/Projects";
import { Skills } from "@/components/Skills";
import { Certificates } from "@/components/Certificates";
import { Interests } from "@/components/Interests";
import { Gallery } from "@/components/Gallery";
import { Resume } from "@/components/Resume";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Toaster position="bottom-right" />
      <Nav />
      <Hero />
      <Marquee />
      <Exploring />
      <About />
      <Education />
      <Experience />
      <Projects />
      <Marquee dark items={["Research in progress", "Human–AI Interaction", "Workplace Wellbeing", "Evidence & Empathy"]} />
      <Skills />
      <Certificates />
      <Interests />
      <Gallery />
      <Resume />
      <Contact />
      <Footer />
    </main>
  );
}
